<template>
    <a
        :href="link.href"
        class="button"
        :class="{ 'is-disabled': link.disabled }"
    >
        <span class="button__wrapper">
            <span class="button__label">
                <span>{{ link.text }}</span>
            </span>
            <span class="button__label button__label-duplicate">
                <span>{{ link.text }}</span>
            </span>
        </span>
    </a>
</template>

<script>

export default {
    props: ['link', 'windowWidth']
};
</script>
